import { Text } from "components/atoms/text/Text";
import { COLORS } from "styles/colors";

export default function NoSubscriptonLabel(): JSX.Element {
  return (
    <Text color={COLORS.VALIDATERED} bold fontSize={13}>
      No Subscription
    </Text>
  );
}
